import React from "react";
import { Button } from "react-bootstrap";
import flashIcon from "../../../../assets/images/flash_icon.svg";

/**
 * Date Selector Component
 * Renders date buttons for selecting VTO offer dates
 */
const DateSelector = ({
    availableDates,
    selectedDates,
    onSelectDate,
    isAfter2330,
    stationTime,
    todayStr,
    isFlashOffer
}) => {
    return (
        <div>
            <div className="button-container">
                {availableDates.map(date => (
                    <Button
                        key={date}
                        className={`button-regular dates ${selectedDates.includes(date) && "selected"}`}
                        data-value={date}
                        style={{ marginTop: 30 }}
                        onClick={() => onSelectDate(date)}
                        disabled={isAfter2330(stationTime) && date === todayStr}
                    >
                        {date}
                    </Button>
                ))}
            </div>

            {/* Flash Offer Warning */}
            {isAfter2330(stationTime) ? (
                <div style={{ display: 'flex', marginTop: 20 }}>
                    <p className="note" style={{ margin: 0, marginLeft: 5, color: 'red' }}>
                        *You can't create a flash offer for today
                    </p>
                </div>
            ) : isFlashOffer && (
                <div style={{ display: 'flex', marginTop: 20 }}>
                    <img src={flashIcon} alt="Flash" />
                    <p className="note" style={{ margin: 0, marginLeft: 5 }}>
                        Flash offers will be created for {todayStr}
                    </p>
                </div>
            )}
        </div>
    );
};

export default DateSelector;
